export const getOperatorName = operator => operator === "||" ? "or" : "and";